import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReporteTarifaRepository } from './reporte-tarifa.repository';
import { ListarTarifaCotizacionRequest, PRI_ReporteTarifa_3Request, PRI_ReporteTarifaRequest, reporteProveedorServicioRequest } from '../pricing/domain/reportes-pricing.request';
import { ListarTarifaCotizacionResponse, PRI_ReporteTarifa_3Response, PRI_ReporteTarifaResponse, ReporteTarifa_v2Response } from '../pricing/domain/reportes-pricing.response';
import { AvanceMensualSupplyVentasRequest } from '../avance-comercial-produccion/domain/reporte-produccion.request';
import { ListaAvanceMensualSupplyResponse } from '../avance-comercial-produccion/domain/reporte-produccion.response';
import { IndicadoresSliRequest } from '../indicadores-sli-venta/domain/indicadores-sli-venta.request';
import { indicadoresSliVtaGraficoResponse, indicadoresSliVtaResponse } from '../indicadores-sli-venta/domain/indicadores-sli-venta.response';
import { indicadoresSliResponse } from '../indicadores-sli/domain/indicadores-sli-venta.response';
import { IndicadoresSliOvRequest } from '../indicadores-sli/domain/indicadores-sli-venta.request';
import { getReporteCostosMensualRequest, SLI_CortesCostoMensual_Request, tnsCorteMensualRequest } from '../sli-costos-mensual/domain/reporte-sli-costos.request';
import { getCorteCostosMensualResponse, getReporteCostosMensualResponse, tnsCorteCostosMensualResponse } from '../sli-costos-mensual/domain/reporte-sli-costos.response';
import { getReporteChangeControllSli_Request, getReporteDetalladoSli_Request, getReporteGenerencialSli_Request } from '../reporte-gerencial-sli/domain/reporte-gerencial-sli.request';
import { getReporteChangeControllSli_Response, getReporteDetalladoSli_Response, getReporteGenerencialSli_Response } from '../reporte-gerencial-sli/domain/reporte-gerencial-sli.response';
// import { PRI_ReporteTarifaRequest } from '../reporte-tarifa-2/domain/reporte-tarifa.request';
// import { PRI_ReporteTarifaResponse } from '../reporte-tarifa-2/domain/reporte-tarifa.response';
@Injectable({
  providedIn: 'root'
})
export class ReporteTarifaService extends ReporteTarifaRepository {
  constructor(
    private readonly http: HttpClient
  ) {
    super();
  }
  override PRI_ReporteTarifa(fd: PRI_ReporteTarifaRequest): Observable<ReporteTarifa_v2Response> {
    return this.http.post<ReporteTarifa_v2Response>(`${environment.PATH_API}/supply/PRI_ReporteTarifa`, fd);
  }
  override PRI_ReporteTarifa_3(fd: PRI_ReporteTarifa_3Request): Observable<PRI_ReporteTarifa_3Response> {
    return this.http.post<PRI_ReporteTarifa_3Response>(`${environment.PATH_API}/supply/PRI_ReporteTarifa_3`, fd);
  }
  override listarAvanceMensualSupply(prolrequest: AvanceMensualSupplyVentasRequest): Observable<ListaAvanceMensualSupplyResponse> {
    return this.http.post<ListaAvanceMensualSupplyResponse>(`${environment.PATH_API}/reporteG/ReporteSupplyAvanceMensual`, prolrequest)
  }
  override getIndicadoresSliVenta(prolrequest: IndicadoresSliRequest): Observable<indicadoresSliVtaResponse> {
    return this.http.post<indicadoresSliVtaResponse>(`${environment.PATH_API}/reporteG/getIndicadoresVtaSli`, prolrequest)
  }

  override getIndicadoresSliVentaGrafico(prolrequest: IndicadoresSliRequest): Observable<indicadoresSliVtaGraficoResponse> {
    return this.http.post<indicadoresSliVtaGraficoResponse>(`${environment.PATH_API}/reporteG/getIndicadoresVtaSli`, prolrequest)
  }

  override reporteProveedorServicio(request: reporteProveedorServicioRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/supply/getServicioProveedor`, request)

  }
  ListarTarifaCotizacion(request: ListarTarifaCotizacionRequest): Observable<ListarTarifaCotizacionResponse> {
    return this.http.post<ListarTarifaCotizacionResponse>(`${environment.PATH_API}/comercial/ListarTarifasCotizacion`, request);
  }

  override reporteDetalleOv(request: IndicadoresSliOvRequest): Observable<indicadoresSliResponse> {
    return this.http.post<indicadoresSliResponse>(`${environment.PATH_API}/supply/getReporteOVDetalle`, request)
  }

  override reporteCostosMensualSli(request: getReporteCostosMensualRequest): Observable<getReporteCostosMensualResponse> {
    return this.http.post<getReporteCostosMensualResponse>(`${environment.PATH_API}/supply/getReporteCostosMensualSli`, request)
  }

  override getCortesCostoMensual(request: SLI_CortesCostoMensual_Request): Observable<getCorteCostosMensualResponse> {
    return this.http.post<getCorteCostosMensualResponse>(`${environment.PATH_API}/supply/getCortesCostoMensual`, request)
  }

  override tnsCortesCostoMensual(request: tnsCorteMensualRequest): Observable<tnsCorteCostosMensualResponse> {
    return this.http.post<tnsCorteCostosMensualResponse>(`${environment.PATH_API}/supply/sliTnsCorteMensualCostos`, request)
  }

  override getReporteGerencialSli(request: getReporteGenerencialSli_Request): Observable<getReporteGenerencialSli_Response> {
    return this.http.post<getReporteGenerencialSli_Response>(`${environment.PATH_API}/supply/getReporteGerencialSli`, request)
  }

  override getReporteDetalladoSli(request: getReporteDetalladoSli_Request): Observable<getReporteDetalladoSli_Response> {
    return this.http.post<getReporteDetalladoSli_Response>(`${environment.PATH_API}/supply/getReporteGerencialSli`, request)
  }

  override getReportechangeControlSli(request: getReporteChangeControllSli_Request): Observable<getReporteChangeControllSli_Response> {
    return this.http.post<getReporteChangeControllSli_Response>(`${environment.PATH_API}/supply/getReporteGerencialSli`, request)
  }

}